<template>
  <div>
    <Title
      >Users and roles
      <Plus
        v-if="firstLoadDone && items.length !== 0 && count !== 0"
        @click="showAdd = true"
      ></Plus
    ></Title>

    <div
      class="notification"
      v-if="firstLoadDone && items.length === 0 && count === 0"
    >
      <p>There are no global admins yet.</p>
      <button
        class="button is-primary"
        @click="set($store.state.auth.user.mail)"
      >
        Make me global admin
      </button>
    </div>

    <p v-if="firstLoadDone && items.length === 0 && count !== 0">
      <i>You don't have access to this page.</i>
    </p>

    <div v-show="firstLoadDone && items.length != 0">
      <div class="is-unselectable">
        <table class="table">
          <thead>
            <tr>
              <th>
                User
              </th>
              <th>
                Role
              </th>
              <th>
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="item of items">
              <tr v-for="role of item.roles" :key="item.user.uid + role.level">
                <td>
                  {{ item.user.mail }}
                </td>
                <td>
                  {{ role.name }}
                </td>
                <td>
                  <button
                    class="button is-small smaller is-danger"
                    @click="
                      selected = { user: item.user, role };
                      showDelete = true;
                    "
                  >
                    Revoke role
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <AddUser v-if="showAdd" v-model="showAdd" @change="add($event)"></AddUser>

    <Confirm
      v-if="selected && showDelete"
      v-model="showDelete"
      @hide="selected = null"
      @confirmed="remove(selected)"
    >
      You are about to remove the global admin role from the user
      {{ selected.user.mail }}.
    </Confirm>
  </div>
</template>

<script>
import { postApi } from "@/utils/http";

export default {
  components: {
    Title: () => import("@/components/singles/Title.vue"),
    Plus: () => import("@/components/main/Plus.vue"),
    AddUser: () => import("@/components/main/settings/AddUser.vue"),
    Confirm: () => import("@/components/main/Confirm.vue"),
  },
  data() {
    return {
      items: [],
      selected: null,
      showDelete: false,
      firstLoadDone: false,
      showAdd: false,
      count: null,
    };
  },
  async created() {
    await this.get();
    await this.getCount();
    this.firstLoadDone = true;
  },
  methods: {
    async remove(item) {
      const index = this.items.findIndex((x) => x.user.uid === item.user.uid);

      await postApi("delete/userRole", {
        userUID2: item.user.uid,
        level: item.role.level,
      });

      this.$delete(this.items, index);
      await this.getCount();
      this.showDelete = false;
      this.selected = null;
    },

    async get() {
      const res = await postApi("get/userRoles");
      this.items = res.filter((x) => x.user);
    },

    async getCount() {
      const res = await postApi("get/userRolesCount");
      this.count = res[0];
    },

    async add(item) {
      const index = this.items.findIndex((x) => x.user.uid === item.user.uid);
      if (!this.items[index]) this.items.push(item);
      await this.getCount();
    },

    async set(mail) {
      const res = await postApi("set/userRole", { mail: mail, level: 0 });

      if (res.length !== 0) {
        this.$helpers.notify(
          "Success",
          "You have to sign out and sign in again for the role to take effect.",
          "success",
          -1
        );

        this.add(res[0]);
      } else {
        this.$helpers.notify("", "The role could not be added.", "warning", -1);
      }
    },
  },
};
</script>
